import { useState } from "react";

export default function MatchTabs({ activeFilter, setActiveFilter, counts }) {

  const tabs = [
    { id: "all", label: "All", count: counts.all },
    { id: "live", label: "Live", count: counts.live },
    { id: "upcoming", label: "Upcoming", count: counts.upcoming },
    { id: "completed", label: "Completed", count: counts.completed },
  ];

  return (
    <div className="mb-6">
      <div
        className="
          inline-flex
          h-11
          w-full
          items-center
          rounded-xl
          bg-gray-100/70
          dark:bg-gray-800/50
          p-1
          overflow-x-auto
          overflow-y-hidden
          whitespace-nowrap
          no-scrollbar
          backdrop-blur
        "
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveFilter(tab.id)}
            className={`
              inline-flex
              items-center
              justify-center
              gap-2
              px-4
              py-2
              text-sm
              font-medium
              rounded-lg
              flex-shrink-0
              transition-all
              duration-300
              focus:outline-none

              ${activeFilter === tab.id
                ? `
                    bg-blue-600
                    text-white
                    shadow-md
                  `
                : `
                    text-gray-600
                    dark:text-gray-400
                    hover:text-gray-900
                    dark:hover:text-white
                  `
              }
            `}
          >
            {tab.label}

            {/* {tab.count && ( */}
              <span
                className={`
                  text-[10px]
                  px-1.5
                  py-0
                  rounded-full
                  font-semibold
                  
                  ${activeFilter === tab.id
                    ? "bg-white/20 text-white"
                    : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
                  }
                `}
              >
                {tab.count}
              </span>
            {/* )} */}
          </button>
        ))}
      </div>
    </div>
  );
}